export const formatDate = (date: Date): string => {
  return date.toISOString().split("T")[0]
}

export const getWeekRange = (date: Date): { start: string; end: string } => {
  const start = new Date(date)
  const day = start.getDay()
  const diff = start.getDate() - day + (day === 0 ? -6 : 1) // Adjust when day is Sunday
  start.setDate(diff)

  const end = new Date(start)
  end.setDate(start.getDate() + 6)

  return {
    start: formatDate(start),
    end: formatDate(end),
  }
}

export const getMonthRange = (date: Date): { start: string; end: string } => {
  const start = new Date(date.getFullYear(), date.getMonth(), 1)
  const end = new Date(date.getFullYear(), date.getMonth() + 1, 0)

  return {
    start: formatDate(start),
    end: formatDate(end),
  }
}

export const calculateAge = (dateOfBirth: string): number => {
  const today = new Date()
  const birthDate = new Date(dateOfBirth)
  let age = today.getFullYear() - birthDate.getFullYear()
  const monthDiff = today.getMonth() - birthDate.getMonth()

  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--
  }

  return age
}

export const isAdult = (dateOfBirth: string): boolean => {
  return calculateAge(dateOfBirth) >= 18
}

export const getCurrentSeason = (): { name: string; startDate: string; endDate: string } => {
  const now = new Date()
  const currentYear = now.getFullYear()
  const currentMonth = now.getMonth() + 1 // JavaScript months are 0-indexed

  if (currentMonth >= 9) {
    // September to December - current season
    return {
      name: `${currentYear}/${currentYear + 1}`,
      startDate: `${currentYear}-09-01`,
      endDate: `${currentYear + 1}-08-31`,
    }
  } else {
    // January to August - previous season started last year
    return {
      name: `${currentYear - 1}/${currentYear}`,
      startDate: `${currentYear - 1}-09-01`,
      endDate: `${currentYear}-08-31`,
    }
  }
}

export const getSeasonsList = (yearsBack = 5): { name: string; startDate: string; endDate: string }[] => {
  const seasons = []
  const currentSeason = getCurrentSeason()
  const currentSeasonStart = Number.parseInt(currentSeason.name.split("/")[0])

  for (let i = 0; i < yearsBack; i++) {
    const seasonStart = currentSeasonStart - i
    seasons.push({
      name: `${seasonStart}/${seasonStart + 1}`,
      startDate: `${seasonStart}-09-01`,
      endDate: `${seasonStart + 1}-08-31`,
    })
  }

  return seasons
}

export const getAgeCategoryForDate = (dateOfBirth: string, competitionDate: string): string => {
  const birthDate = new Date(dateOfBirth)
  const compDate = new Date(competitionDate)
  const age = compDate.getFullYear() - birthDate.getFullYear()

  // Adjust age if birthday hasn't occurred yet in the competition year
  const birthdayThisYear = new Date(compDate.getFullYear(), birthDate.getMonth(), birthDate.getDate())
  const adjustedAge = compDate >= birthdayThisYear ? age : age - 1

  if (adjustedAge >= 23) return "Adult"
  if (adjustedAge >= 20) return "U23"
  if (adjustedAge >= 17) return "U20-Junior"
  if (adjustedAge >= 15) return "U17-Cadet"
  if (adjustedAge >= 14) return "U15"
  if (adjustedAge >= 13) return "U14"
  if (adjustedAge >= 11) return "U13"
  if (adjustedAge >= 9) return "U11"
  return "U9"
}
